'use client';

import cn from 'classnames';
import { Button } from '@/shared/ui/core';
import { openCookieSettings } from '../model/cookie-consent.store';
import styles from './cookie-consent.module.scss';


type ComponentProps = {
    className?: string;
};


export function CookieConsentTrigger ({ className }: ComponentProps) {
    return (
        <Button
            variant='naked'
            className={ cn(styles.cookie_consent_trigger, className) }
            onClick={ openCookieSettings }
        >
            Cookie consent
        </Button>
    );
}
